import { styled } from '@mui/material/styles';
import { Card, IconButton } from '@mui/material';
import { BRAND_COLORS, alpha } from '../../../styles/theme';

export const MaintenanceItemCard = styled(Card)<{ $overdue?: boolean }>(({ $overdue }) => ({
  backgroundColor: BRAND_COLORS.white.main,
  border: `1px solid ${$overdue ? BRAND_COLORS.yellow.main : alpha(BRAND_COLORS.forestGreen.main, 0.2)}`,
  borderRadius: '8px',
  boxShadow: 'none',
}));

export const CollapsibleMaintenanceCard = styled(Card)<{ $overdue?: boolean }>(({ $overdue }) => ({
  backgroundColor: $overdue ? alpha(BRAND_COLORS.yellow.main, 0.05) : alpha(BRAND_COLORS.forestGreen.main, 0.05),
  border: `1px solid ${$overdue ? BRAND_COLORS.yellow.main : alpha(BRAND_COLORS.forestGreen.main, 0.3)}`,
  borderRadius: '8px',
  boxShadow: 'none',
}));

export const ExpandMoreStyled = styled(IconButton)<{ $expanded: boolean }>(({ $expanded }) => ({
  transform: !$expanded ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: 'transform 0.2s ease',
}));
